document.addEventListener("DOMContentLoaded", () => {
    publish(PUB_SUB_EVENTS.ffProgresBarUpdate, { 'questionIndex': 1, 'isQuestionNext': true });
    setCookieUtm();
});

const setCookieUtm = () => {
    const utmCampaign = UrlUtils.getQueryParam('utm_campaign');
    if (!utmCampaign) return;
    if (CookieUtils.setCookie) {
        CookieUtils.setCookie('utm', utmCampaign.toLowerCase(), 30);
    }
};
